import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthorized-view',
  templateUrl: './unauthorized-view.component.html',
  styleUrls: ['./unauthorized-view.component.scss']
})
export class UnauthorizedViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
